<script setup>
  import { ref, computed, provide, onMounted } from 'vue';
  import { useIntersectionObserver } from '@vueuse/core'

  const container = defineModel('container')

  const props = defineProps({
    lazy: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: String,
      required: false
    },
    contentClass: {
      type: String,
      required: false
    }    
  });

  const target = ref(null);
  const targetIsVisible = ref(false);

  const styles = computed(() => props.minHeight ? { minHeight: minHeight.value } : '' );
  const minHeight = computed(() => props.minHeight);

  provide('minHeight', minHeight);

  onMounted(() => container.value = target.value);

  const { stop } = useIntersectionObserver(
    target,
    ([{ isIntersecting }]) => {
      targetIsVisible.value = isIntersecting;

      if (isIntersecting) stop();
    },
    {
      rootMargin: '300px'
    }
  )    
</script>

<template>
  <section ref="target" class="jwx-data-container-section" :style="styles">
    <header v-if="$slots.title || $slots.metaActions" class="jwx-data-container-section__header">
      <h2 v-if="$slots.title" class="jwx-data-container-section__title jwx-page-block-title">
        <slot name="title"></slot>
      </h2>
      <div v-if="$slots.metaActions" class="jwx-data-container-section__meta-actions">
        <slot name="metaActions"></slot>
      </div>
    </header>
    <div
      class="jwx-data-container-section__content"
      :class="props.contentClass"
    >
      <slot name="content" :isVisible="targetIsVisible"></slot>
    </div>
    <footer v-if="$slots.footer" class="jwx-data-container-section__footer">
      <slot name="footer"></slot>
    </footer>
  </section>
</template>